(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pokemon-sparkline"] && !Shopify.designMode) return;
  try {
    /* Sparkline-Hover: Tooltip mit Datum + Preis pro Messpunkt, Cursor-Punkt auf der
   Linie. Event-Delegation auf dem SVG (bis zu 365 Trefferfelder). Preisformat =
   window.hdk.kartenPreis (assets/hdk-util.js, unit-getestet; Liquid-Zwilling
   snippets/pokemon-preis.liquid). Aufgerufen erst beim Hover — dieser Block laeuft
   aus Shopifys gebuendelter scripts.js im <head> VOR hdk-util.js, window.hdk steht
   also beim Ausfuehren noch nicht, beim ersten Zeigen aber sicher. */
(function () {
  document.querySelectorAll('.pkspark').forEach(function (fig) {
    var svg = fig.querySelector('.pkspark__svg');
    var tip = fig.querySelector('.pkspark__tip');
    var cursor = fig.querySelector('.pkspark__cursor');
    if (!svg || !tip) return;
    var symbol = fig.dataset.symbol || '';

    function formatPreis(cents) {
      return window.hdk.kartenPreis(cents / 100, symbol);
    }
    function formatDatum(iso) {
      var t = iso.split('-');
      return t.length === 3 ? t[2] + '.' + t[1] + '.' + t[0] : iso;
    }

    function zeigen(hit) {
      var cents = parseInt(hit.getAttribute('data-c'), 10);
      if (isNaN(cents)) return;
      tip.textContent = formatDatum(hit.getAttribute('data-d') || '') + ' · ' + formatPreis(cents);
      tip.hidden = false;
      if (cursor) {
        cursor.setAttribute('cx', hit.getAttribute('cx'));
        cursor.setAttribute('cy', hit.getAttribute('cy'));
        cursor.classList.add('pkspark__cursor--on');
      }
      var fr = fig.getBoundingClientRect();
      var hr = hit.getBoundingClientRect();
      var x = hr.left + hr.width / 2 - fr.left;
      var y = hr.top - fr.top;
      /* Erst positionieren, dann horizontal in die Figure klemmen (Randpunkte). */
      tip.style.top = y + 'px';
      tip.style.left = x + 'px';
      var halb = tip.offsetWidth / 2;
      if (x < halb) tip.style.left = halb + 'px';
      if (x > fr.width - halb) tip.style.left = (fr.width - halb) + 'px';
    }
    function verbergen() {
      tip.hidden = true;
      if (cursor) cursor.classList.remove('pkspark__cursor--on');
    }

    svg.addEventListener('pointerover', function (ev) {
      var hit = ev.target.closest && ev.target.closest('.pkspark__hit');
      if (hit) zeigen(hit);
    });
    svg.addEventListener('pointerleave', verbergen);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
